<template>
  <div >
    <div
        v-if="show && isSushiHub"
        style="background: #f04653"
        class="p-3 "
    >
      <div class="container text-white  d-flex justify-content-between align-items-center ">

        <span style="font-size: 22px" class="montserrat-700 ">{{ activeState == "All" ? $t("message.all") : activeState | Capitalize }} {{ $t("message.stores") }}</span>



        <ul
            class="d-flex align-items-center m-0"
            style="display: flex, listStyle: none"
        >
          <li
              class="nav-item text-white m-0 "
              style="display: inline-block"
              v-for="st in this.allowedState"
              :key="st"
          >
            <a
                style="font-size: 22px"
                class="nav-link montserrat-700 "
                :class="{ active: activeState === st, 'text-white' : !isSushiHub, 'sushi-state-text' : isSushiHub &&  activeState !== st, 'text-white' : activeState === st && isSushiHub }"
                @click.prevent="filterStore(st)"
                href="#"
            >{{ st == "All" ? $t("message.all") : st }}</a
            >
          </li>
        </ul>
      </div>






    </div>

    <div v-if="!isSushiHub">

      <div v-if="allowedState.length > 2" class="state-menu col-md-12">
        <nav class="navbar navbar-expand navbar-light bg-light state-menu">
          <button
              class="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#navbarTogglerDemo01"
              aria-controls="navbarTogglerDemo01"
              aria-expanded="false"
              aria-label="Toggle navigation"
          ></button>
          <div class="collapse navbar-collapse" id="navbarTogglerDemo01">
            <ul class="navbar-nav mr-auto mt-2 mt-lg-0">
              <li class="nav-item" v-for="st in this.allowedState" :key="st">
                <a
                    class="nav-link"
                    :class="{ active: activeState === st }"
                    @click.prevent="filterStore(st)"
                    href="#"
                >{{ st == "All" ? $t("message.all") : st }}</a
                >
              </li>
            </ul>
          </div>
        </nav>
      </div>
      <h2>{{ activeState == "All" ? $t("message.all") : activeState | Capitalize }} {{ $t("message.restaurants") }}</h2>

    </div>

    <div  v-if="show" class="container">
      <div class="row mt-4" v-if="isSushiHub">
        <div v-for="rs in orderedResturants" :key="rs.ID" class=" col-lg-3 col-md-4  mb-4">
          <SushiCard :rs="rs" :pos="pos" />

        </div>
      </div>

      <div class="row mt-4" v-else>
        <div v-for="rs in orderedResturants" :key="rs.ID" class="col-md-3 mb-4">

          <div class="rs-item">
            <div class="badge" v-if="storeClosed(rs)">
              {{ $t("message.closed") }}
            </div>
            <a @click="navigateToStore(rs)">
              <div
                  :style="{ 'background-image': 'url(' + rs.ProfileImage + ')' }"
                  class="w-100 rs-img-item"
              >
                            <span v-if="pos" class="fs-90">
                              <i class="material-icons">near_me</i>
                              {{ distance(rs.Location.Latitude, rs.Location.Longitude) }}km
                              {{ $t("message.away") }}
                            </span>
              </div>
              <span class="d-block mt-2 font-weight-bold">{{ rs.Name }}</span>
              <div>{{ rs.StoreTitle }}</div>
              <div v-if="getOperatingHours(rs)" class="fs-80 color-gray">
                {{ $t("message.open") }}
                <span>{{ getOperatingHours(rs).openTime }}</span>
                {{ $t("message.toName") }}
                <span>{{ getOperatingHours(rs).closeTime }}</span>
              </div>
            </a>
          </div>

        </div>
      </div>
    </div>
    <div v-else>
      <message :message="getNoStoreAvailableInDatabaseLang" v-show="!busy" />
      <progressindicator v-show="busy" style="opacity: 0.4"></progressindicator>
    </div>
  </div>
</template>

<script>
import shared from "../../../sharedscripts/master/Resturant/ResturantsFilter.js";
import Progressindicator from "../../progressindicator";
import Message from "../../shared/Message";
import SushiCard from "../../sushiHub/sushiCard";
export default {
  components: {
    Progressindicator,
    Message,
    SushiCard,
  },
  filters: {
    ...shared.filters,
  },
  props: {
    activeState: {
      type: String,
      default: "All",
    },
  },
  data() {
    return {
      populars: [],
      pos: null,
      busy: false,
      states: ["All", "ACT", "NSW", "NT", "QLD", "SA", "TAS", "VIC", "WA"],
    };
  },
  computed: {
    ...shared.computed,
    isSushiHub() {
      return this.hqDoc && this.hqDoc.IsSushiHub
    },
  },
  created() {
    this.checkLocation();
  },
  mounted() {
    this.getStores();
  },
  methods: {
    ...shared.methods,
  },
};
</script>
